import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import HizmetDetay from '../../components/HizmetDetay';
import bulasikMakineResmi from '../../assets/bulasik-makinesi-teknik-servis.webp';
import AOS from 'aos';
import 'aos/dist/aos.css';

function BulasikMakinesiServisi() {
  // --- AOS VE DİNAMİK BAŞLIK AYARI ---
  useEffect(() => {
    // Sekme ismini kesin olarak güncelliyoruz
    document.title = "Ankara Bulaşık Makinesi Teknik Servis | 7/24 Tamir";
    
    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  // --- GOOGLE İÇİN ÖZEL BULAŞIK MAKİNESİ SERVİS ŞEMASI (JSON-LD) ---
  const dishWasherSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Bulaşık Makinesi Teknik Servis",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Ankara Merkez Teknik",
      "telephone": "+903125810881",
      "areaServed": "Ankara"
    },
    "description": "Ankara genelinde Bosch, Arçelik, Beko ve Siemens bulaşık makineleri için 7/24 garantili tamir. Isıtma pompası, kart tamiri ve su sızıntısı onarımı.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Bulaşık Makinesi Onarım Hizmetleri",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bulaşık Makinesi Pompa Değişimi" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Rezistans ve Isıtma Onarımı" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Hata Kodu (E09, E15) Çözümü" } }
      ]
    }
  };

  return (
    <>
      <Helmet>
        <title>Ankara Bulaşık Makinesi Teknik Servis | 7/24 Tamir</title>
        <meta name="description" content="Ankara'da her marka bulaşık makinesi için 7/24 garantili tamir hizmeti. Bosch, Arçelik, Beko, Siemens servisi. 1 yıl parça garantili profesyonel çözümler!" />
        {/* Google botları için teknik veri kartı */}
        <script type="application/ld+json">
          {JSON.stringify(dishWasherSchema)}
        </script>
      </Helmet>

      <div data-aos="fade-up">
        <HizmetDetay 
          icon="🍽️"
          baslik="Ankara Bulaşık Makinesi Teknik Servis"
          stat1="Uzman Çözüm"
          stat2="Aynı Gün"
          resim={bulasikMakineResmi}
          aciklama="Bulaşık makineniz su mu almıyor, suyu ısıtmıyor veya bardaklarınızı çizikli mi çıkarıyor? Ankara'nın tüm ilçelerinde orijinal parça garantili tamir ve bakım hizmeti sunuyoruz."
          seoMetni={(
            <>
              {/* SEO KART 1: GENEL HİZMET */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="100">
                <h4>Ankara Geneli Hızlı Bulaşık Makinesi Onarımı</h4>
                <p>
                  Mutfaktaki en büyük yardımcınız arızalandığında <strong>bulaşık makinesi teknik servis</strong> ekiplerimizle anında kapınızdayız. <strong>Çankaya</strong>, <strong>Keçiören</strong>, <strong>Yenimahalle</strong> ve <strong>Altındağ</strong> talepleriniz uzman ekiplerimizce aynı gün çözülür.
                </p>
              </div>

              {/* SEO KART 2: YERLİ MARKALAR */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="200">
                <h4>Yerli Cihazlarda Orijinal Parça Güvencesi</h4>
                <p>
                  <strong>Arçelik</strong>, <strong>Beko</strong>, <strong>Vestel</strong> ve <strong>Profilo</strong> bulaşık makinelerinde yıkama motoru ve rezistans değişimlerini %100 orijinal parçalarla yapıyoruz. <strong>Mamak</strong>, <strong>Pursaklar</strong> ve <strong>Sincan</strong> bölgelerinde 1 yıl parça garantisi veriyoruz.
                </p>
              </div>

              {/* SEO KART 3: ALMAN TEKNOLOJİSİ */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="300">
                <h4>Alman Teknolojisi ve E09 Isıtma Arızaları</h4>
                <p>
                  Alman cihazlarının kronik E09 ısıtma ve E15 su kaçağı hatalarını noktasal tespit ediyoruz. <strong>Bosch bulaşık makinesi teknik servis</strong> ve <strong>Siemens</strong> arayışlarınızda <strong>Eryaman</strong> ve çevresinde profesyonel kart onarımı sağlıyoruz.
                </p>
              </div>

              {/* SEO KART 4: PREMİUM ÇÖZÜMLER */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="400">
                <h4>Asya Teknolojisi ve Premium Ankastre Çözümleri</h4>
                <p>
                  <strong>Samsung</strong> ve <strong>LG</strong> bulaşık makinesi hata kodlarına anında müdahale ediyoruz. Ankastre grubunda <strong>Franke</strong>, <strong>Hoover</strong> ve <strong>Hotpoint Ariston</strong> tamiri ile cihazınızı ilk günkü yıkama performansına kavuşturuyoruz.
                </p>
              </div>
            </>
          )}
        />
      </div>
    </>
  );
}

export default BulasikMakinesiServisi;